import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import { MdModeEdit } from 'react-icons/md'
import Skeleton from '@material-ui/lab/Skeleton'
import { useHistory, useRouteMatch } from 'react-router-dom'

import EditManufacturer from '../Forms/Manufacturer/EditManufacturer'
import useMediaPath from 'hooks/useMediaPath'
import styles from '../vehicle.module.scss'
import PreviewComponent from 'components/Global/Preview'

const Manufacturers = ({ setMessages, data, setSelected }) => {
  const [editable, setEditable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [update, setUpdate] = useState(false)
  const [active, setActive] = useState()

  const mediaPath = useMediaPath()
  let { url } = useRouteMatch()
  const history = useHistory()

  const updateUrl = link => {
    history.push(link)
  }
  return (
    <div className={styles.content}>
      {!loading
        ? data.map((mft, i) => (
            <div className={styles.cardWrapper} key={i}>
              <PreviewComponent
                title={mft.name}
                details={mft.details}
                preview={mediaPath(mft.logo)}
                componentType="thumbnail"
                previewSize={[200, 200]}
                onClickFn={() => {
                  setSelected(mft.id)
                  updateUrl(`${url}/${mft.name}`)
                }}
                actions={[
                  <IconButton
                    key={1}
                    onClick={() => {
                      setActive(mft.id)
                      setEditable(mft.id)
                    }}
                    color="secondary"
                  >
                    <MdModeEdit />
                  </IconButton>,
                ]}
              />
              {editable && mft.id === active && (
                <EditManufacturer
                  editable={editable}
                  setEditable={setEditable}
                  mft={mft}
                  setMessages={setMessages}
                  loading={setLoading}
                  update={setUpdate}
                />
              )}
            </div>
          ))
        : [...Array(10)].map((i, e) => {
            return (
              <Skeleton
                key={e}
                variant="rect"
                width={200}
                height={272}
                className={styles.dManufacturercard}
              />
            )
          })}
    </div>
  )
}

export default Manufacturers
